
export default function DealSpotNGLogo() {
  const iconUrl = `${process.env.PUBLIC_URL || ''}/assets/images/dealspotngicon.png`;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    }}>
      <img
        src={iconUrl}
        alt=""
        style={{ width: 'var(--logo-icon-size, 36px)', height: 'var(--logo-icon-size, 36px)', objectFit: 'contain', margin: '0' }}
      />
      <div style={{
        fontSize: 'var(--logo-font-size, 24px)',
        fontWeight: '900',
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '-0.5px',
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif'
      }}>
        <span style={{ color: '#00838F' }}>Deal</span>
        <span style={{ color: '#F57C00' }}>Spot</span>
        <span style={{ color: '#00838F' }}>NG</span>
      </div>
    </div>
  );
}
